<!--
  责任区页面参数介绍：
  lon：经度 （非必填）
  lat：纬度 （非必填）
-->

<template>
  <div class="dhmap-wrapper" id="dhmap-wrapper">
    <!-- <div v-if="showNoZrqInfo" class="infotip" style="background-color: #1989fa">
      {{ $t("gisMsg.infotip") }}
    </div> -->
    <div class="gisinfobox" v-if="sth">
      {{ sth }}
    </div>
    <div id="zrqmap" ref="zrqmap"></div>
    <van-tabbar
      v-if="toolbar"
      v-model="active"
      active-color="#07c160"
      @change="onChange"
    >
      <van-tabbar-item icon="sign">{{ $t("gisMsg.signTit") }}</van-tabbar-item>
      <van-tabbar-item icon="brush-o">{{
        $t("gisMsg.brushTit")
      }}</van-tabbar-item>
      <van-tabbar-item icon="search">{{
        $t("gisMsg.searchTit")
      }}</van-tabbar-item>
      <van-tabbar-item icon="apps-o">{{ $t("gisMsg.apps") }}</van-tabbar-item>
    </van-tabbar>
    <!-- <div class="gistoolbox" v-if="toolbar">
      <van-button plain type="info" round @click="setmyview"
        ><van-icon name="location-o" size="16"
      /></van-button>
      <van-button plain type="info" round @click="setview"
        ><img src="../../assets/gisicon/icon_globle.png"
      /></van-button>
    </div> -->
    <van-popup
      v-model="showLayerControl"
      round
      position="bottom"
      :overlay="false"
      :closeable="false"
      @opened="openToobar"
      :lock-scroll="false"
      :style="{
        height: '45%',
        padding: '40px 0px 0px 0px',
        marginBottom: '1.33333rem',
        background: '#fff',
      }"
    >
      <div class="taskPopClose" @click="closeToobar('showLayerControl')">
        <van-icon name="cross"  size="22" color="#c8c9cc"/>
      </div>
      <van-tree-select
        :items="layercontrol.items"
        :active-id.sync="layercontrol.activeIds"
        :main-active-index.sync="layercontrol.activeIndex"
        @click-item="handleLayerVisible"
        height="100%"
      />
    </van-popup>
    <van-popup
      v-model="showRenderControl"
      round
      position="bottom"
      :overlay="false"
      :closeable="false"
      @opened="openToobar"
      :style="{
        height: '45%',
        padding: '35px 0px 0px 0px',
        marginBottom: '1.33333rem',
        background: '#fff',
      }"
    >
      <div class="taskPopClose" @click="closeToobar('showRenderControl')">
        <van-icon name="cross"  size="22" color="#c8c9cc"/>
      </div>
      <van-tree-select
        :items="rendercontrol.items"
        :active-id.sync="rendercontrol.activeIds"
        :main-active-index.sync="rendercontrol.activeIndex"
        @click-nav="handleRenderSelect"
        @click-item="handleRenderItemSelect"
        height="100%"
      />
    </van-popup>

    <van-popup
      v-model="showSearchControl"
      round
      position="bottom"
      :overlay="false"
      :closeable="false"
      @opened="openToobar"
      :style="{
        height: '68%',
        padding: '35px 0px 0px 0px',
        marginBottom: '1.33333rem',
        background: '#fff',
      }"
    >
      <div class="taskPopClose" @click="closeToobar('showSearchControl')">
        <van-icon name="cross"  size="22" color="#c8c9cc"/>
      </div>
      <div style="height: calc(100% - 1px); overflow: auto">
        <search 
          :showTask="false"
          @onLocate="handleLocate"
          :param="{ zrqlx: currentZrqlx, objid: currentZrqObjid }"
        />
      </div>
    </van-popup>
    <van-popup
      v-model="showPropertyControl"
      round
      position="bottom"
      :overlay="false"
      :closeable="false"
      @opened="openToobar"
      :style="{
        height: '55%',
        padding: '35px 0px 0px 0px',
        marginBottom: toolbar?'1.33333rem':0,
        background: '#fff',
      }"
    >
      <div class="taskPopClose" @click="closeToobar('showPropertyControl')">
        <van-icon name="cross"  size="22" color="#c8c9cc"/>
      </div>
      <div style="height: calc(100% - 1px); overflow: auto">
        <administrativeAreaMsg
          v-if="
            propertycontrol.type == 'geo_sheng' ||
            propertycontrol.type == 'geo_shi' ||
            propertycontrol.type == 'geo_xian' ||
            propertycontrol.type == 'geo_xiang' ||
            propertycontrol.type == 'geo_cun'
          "
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <dutyArea
          v-if="
            propertycontrol.type == 'geo_grid_sheng' ||
            propertycontrol.type == 'geo_grid_shi' ||
            propertycontrol.type == 'geo_grid_xian' ||
            propertycontrol.type == 'geo_grid_xiang' ||
            propertycontrol.type == 'geo_grid_cun'
          "
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <linLongMsg
          v-if="propertycontrol.type == 'v_lz'"
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <olfTree
          v-if="propertycontrol.type == 'geo_gushu'"
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <forest
          v-if="propertycontrol.type == 'geo_xiaoban'"
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <wetlandMsg
          v-if="propertycontrol.type == 'geo_shidi'"
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <zrbhdMsg
          v-if="propertycontrol.type == 'geo_baohudi'"
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <sthxMsg
          v-if="propertycontrol.type == 'geo_hongxian'"
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <findMsg
          v-if="propertycontrol.type == 'sys_discover'"
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <monitorMsg
          v-if="propertycontrol.type == 'geo_monitor'"
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
        <billboardMsg
          v-if="propertycontrol.type == 'geo_board'"
          :param="{
            id: propertycontrol.id,
            type: propertycontrol.type,
            showMap: false,
          }"
        />
      </div>
    </van-popup>
    <van-popup
      v-model="showOptControl"
      round
      position="bottom"
      :overlay="false"
      :closeable="false"
      @opened="openToobar"
      :style="{
        height: '50%',
        padding: '40px 0px 0px 0px',
        marginBottom: '1.33333rem',
        background: '#f9f9f9',
      }"
    >
      <div class="taskPopClose" @click="closeToobar('showOptControl')">
        <van-icon name="cross"  size="22" color="#c8c9cc"/>
      </div>
      <!-- <van-cell-group style=""> -->
      <div style="height: calc(100% - 1px); overflow: auto">
        <van-field
          :label="$t('gisMsg.appSignTit') + '：'"
          :placeholder="$t('gisMsg.selectSignTit')"
          v-model="layerpicker.currentLayer.text"
          readonly
          clickable
          @touchstart.native.stop="layerpicker.showpicker = true"
        />
        <p
          style="
            line-height: 35px;
            font-size: 14px;
            padding-left: 15px;
            color: #666;
            margin-top: 10px;
          "
        >
          <em> {{ $t("gisMsg.appSignTit") }}</em>
        </p>
        <van-field readonly name="radio" :label="$t('gisMsg.sxTit')">
          <van-switch
            v-model="optcontrol.queryProps"
            slot="right-icon"
            active-color="#07c160"
            size="24"
          />
        </van-field>
        <van-field readonly name="radio" :label="$t('gisMsg.jlTit')">
          <van-switch
            v-model="juanlian"
            slot="right-icon"
            active-color="#07c160"
            size="24"
          />
        </van-field>
        <p
          style="
            line-height: 35px;
            font-size: 14px;
            padding-left: 15px;
            color: #666;
            margin-top: 10px;
          "
        >
          {{ $t("gisMsg.signMsgTit") }}
        </p>
        <van-field center readonly :label="$t('gisMsg.tlTit')">
          <van-button
            round=""
            slot="button"
            size="small"
            @click="
              showOptControl = false;
              symbolcontrol.showsymbol = true;
            "
            type="primary"
            >{{ $t("gisMsg.seeTlTit") }}</van-button
          >
        </van-field>
        <van-field
          center
          readonly
          :value="optcontrol.scaleinfo"
          input-align="right"
          :label="$t('gisMsg.scaleinfoTit')"
        />
        <van-field
          v-if="optcontrol.lonlat != ''"
          center
          readonly
          :value="fmtlonlat"
          input-align="right"
          :label="$t('gisMsg.fmtlonlatTit')"
        >
          <!-- <van-button round="" slot="button" size="small" type="primary" @click="setmyview">定位</van-button> -->
        </van-field>

        <!-- <van-field
          center
          readonly
          label="全图">
          <van-button round="" slot="button" size="small" type="primary" @click="setview">全图</van-button>
        </van-field> -->
      </div>
      <!-- </van-cell-group> -->
    </van-popup>
    <van-popup
      v-model="slidercontrol.showSlider"
      position="bottom"
      :overlay="false"
      :closeable="true"
      @close="
        juanlian = false;
        slidercontrol.sliderValue = 0;
        map.render();
      "
      :style="{
        height: '85px',
        padding: '50px 45px 0px 45px',
        marginBottom: '1.33333rem',
        background: '#fff',
      }"
    >
      <van-slider v-model="slidercontrol.sliderValue" @input="handleSliding" />
    </van-popup>
    <van-popup
      v-model="symbolcontrol.showsymbol"
      round
      position="bottom"
      :overlay="false"
      :closeable="true"
      :style="{
        height: '320px',
        padding: '42px 0px 0px 0px',
        marginBottom: '1.33333rem',
        background: '#f9f9f9',
        overflow: 'hidden',
      }"
    >
      <van-tabs v-model="symbolcontrol.symbolactive" color="#07c160">
        <van-tab
          v-for="item in symbolcontrol.source"
          :key="item.groupName"
          :title="item.groupName"
          style="height: 240px; overflow: auto"
        >
          <div v-for="subitem in item.groupItems" :key="subitem.title">
            <p class="symboltitle">{{ subitem.title }}</p>
            <van-grid>
              <van-grid-item
                v-for="symbol in subitem.symbols"
                :key="symbol.name"
                :text="symbol.name"
              >
                <div
                  v-if="symbol.type == 'icon'"
                  slot="icon"
                  style="padding: 10px 0px"
                >
                  <div
                    :style="{
                      width: '45px',
                      height: '22px',
                      textAlign: 'center',
                    }"
                  >
                    <img :src="symbol.icon" />
                  </div>
                </div>
                <div
                  v-if="symbol.type == 'area'"
                  slot="icon"
                  style="padding: 10px 0px"
                >
                  <div
                    :style="{
                      width: '45px',
                      height: '20px',
                      background: symbol.icon,
                    }"
                  ></div>
                </div>
                <div
                  v-if="symbol.type == 'line'"
                  slot="icon"
                  style="padding: 19px 0px"
                >
                  <div
                    :style="{
                      width: '45px',
                      height: symbol.height,
                      background: symbol.icon,
                    }"
                  ></div>
                </div>
              </van-grid-item>
            </van-grid>
          </div>
        </van-tab>
      </van-tabs>
    </van-popup>
    <van-popup
      v-model="layerpicker.showpicker"
      :overlay="false"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="layerpicker.layerItems"
        @cancel="
          layerpicker.currentLayer = {};
          juanlian = false;
          layerpicker.showpicker = false;
        "
        @confirm="onTargetLayerConfirm"
      />
    </van-popup>
    <!-- 提示有限制的查看责任区信息 -->
    <!-- 因数据安全需要，已设置安全限制GIS数据将无法访问和查看！ -->
    <van-notice-bar left-icon="volume-o" :scrollable="false" class="vanSwipe" v-if="isFilter">
      <van-swipe
        vertical
        class="noticeSwiper"
        :autoplay="3000"
        :show-indicators="false"
      >
        <van-swipe-item
          >因数据安全需要，已设置安全限制GIS数据将无法访问和查看！</van-swipe-item
        >
        <van-swipe-item
          >因数据安全需要，已设置安全限制GIS数据将无法访问和查看！</van-swipe-item
        >
        <van-swipe-item
          >因数据安全需要，已设置安全限制GIS数据将无法访问和查看！</van-swipe-item
        >
      </van-swipe>
    </van-notice-bar>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
import "ol/ol.css";
import {
  initMap,
  addLayerToMap,
  addLocateLayerToMap,
  actLocate,
  actLocateOne,
  getLayerTree,
  actTroggleLayer,
  mapConfig,
  actRenderLayer,
  actLocateByCoordinate,
  getLayerByType,
  removeAllLayersExceptBaseMap,
  getLocateLayer,
  removeAllLayers,
} from "@/utils/MapUtils";
import { Vector as VectorLayer } from "ol/layer.js";
import VectorSource from "ol/source/Vector.js";
import { Style, Stroke, Fill, Text, Circle, Icon } from "ol/style.js";
import Feature from "ol/Feature";
import ScaleLine from "ol/control/ScaleLine";
import search from "../search/search";
import administrativeAreaMsg from "../universal/administrativeAreaMsg";
import dutyArea from "../universal/dutyArea";
import linLongMsg from "../universal/linLongMsg";
import olfTree from "../universal/oldTree";
import forest from "../universal/forest";
import wetlandMsg from "../universal/wetlandMsg";
import zrbhdMsg from "../universal/zrbhdMsg";
import sthxMsg from "../universal/sthxMsg";
import findMsg from "../universal/findMsg";
import monitorMsg from "../universal/monitorMsg";
import billboardMsg from "../universal/billboardMsg";
import { locateStyleCollection } from "@/utils/MapIcons";
import Point from "ol/geom/Point";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import Overlay from "ol/Overlay";
import MultiPolygon from "ol/geom/MultiPolygon";
import {
  containsExtent,
  getTopLeft,
  getTopRight,
  getBottomLeft,
  getBottomRight,
} from "ol/extent";
export default {
  name: "zrq",
  props: {
    param: { type: Object, default: () => {return {}}},
    mode: { type: String, default: "web" },
    mapData:{ type: Object, default: () => {return {}}},
  },
  // components: {search,administrativeAreaMsg,dutyArea},
  components: {
    search,
    administrativeAreaMsg,
    dutyArea,
    linLongMsg,
    olfTree,
    forest,
    wetlandMsg,
    zrbhdMsg,
    sthxMsg,
    findMsg,
    monitorMsg,
    billboardMsg,
  },
  data() {
    return {
      // mapData:{
      //   zrqlx:'geo_xian',//责任区geo_grid_shi,还是政区geo_shi
      //   zrqobjid:'16ca0d0d-e8d4-414e-bbd1-44af3156a83c',//objid
      //   toolbar: "block",
      // },
      isFilter:false,//是否脱敏提示
      haszrq: false,
      toolbar: false,  
      showNoZrqInfo: false,
      active: -1,
      showLayerControl: false,
      showRenderControl: false,
      showSearchControl: false,
      showOptControl: false,
      showPropertyControl: false,
      layercontrol: {
        items: [],
        activeIds: [1, 2, 3, 4, 6],
        activeIndex: 0,
      },
      rendercontrol: {
        items: mapConfig.render,
        activeIndex: 0,
        activeIds: "geo_xiaoban",
        lindiType: "geo_xiaoban",
        shidiType: "geo_shidi",
        baohudiType: "geo_baohudi",
      },
      optcontrol: {
        queryProps: true,
        lonlat: "",
        scaleinfo: "",
      },
      juanlian: false,
      slidercontrol: {
        showSlider: false,
        sliderValue: 0,
      },
      symbolcontrol: {
        showsymbol: false,
        symbolactive: 0,
        source: mapConfig.symbol,
      },
      layerpicker: {
        showpicker: false,
        layerItems: [],
        currentLayer: {},
      },
      propertycontrol: {
        type: "",
        id: "",
      },
      zrqVector: null,
      zrqSourceVector: null,
      zrqStyle: new Style({
        stroke: new Stroke({
          color: "#2a32fc",
          width: 2.5,
        }),
      }),
      blankStyle: new Style({
        fill: new Fill({
          color: [0, 0, 0, 0],
        }),
      }),
      gisconfig: {},
      map: null,
      currentZrqlx: null,
      currentZrqObjid: null,
      clientType: "",
      sth: null,

      cutfeature: null,
      cutflag: true,
      dataGisType:[],//脱敏gis图层，脱敏的图层不展示
      baseGisType:["geo_xiaoban","geo_shidi","geo_baohudi","geo_jbntbhtb","geo_hongxian"],//参与脱敏的数据
    };
  },
  mounted() {
    window.locateByNative = this.locateByNative;
    window.toolbarChange=this.toolbarChange;//点击周边详情，是否展示状态栏
    this.clientType = getDeviceType();
    //获取经纬度
    if (this.$route.query.lon && this.$route.query.lat) {
      this.optcontrol.lonlat =
        this.$route.query.lon + "," + this.$route.query.lat;
    }
    this.$nextTick(() => {
      //如果是组件引用，当检测到toolbar=none时，隐藏所有工具栏
      if (this.mapData.toolbar == "none") {
        this.toolbar = false;
      }
      if (this.mapData.zrqobjid && this.mapData.zrqlx && this.userinfo) {
        this.loadMap();
      }
    });
  },

  methods: {
    // 打开整个toolbar
    openToobar(){
      
      let _this=this;
      setTimeout(()=>{
        console.log("openToobar")
        if (_this.clientType == "android") {
          window.android.getInfo(123,'0');
        } else {
          window.webkit.messageHandlers.showBtn.postMessage('0');
        }
        _this.toolbar = true;
      },100)
      
    },
    // 点击关闭按钮，关闭整个toolbar
    closeToobar(indexName){
      console.log(indexName,this[indexName],'closeToobar')
      this[indexName] = false;
      this.toolbar = false;
      let _this=this;
      if (_this.clientType == "android") {
        window.android.getInfo(123,'1');
      } else {
        window.webkit.messageHandlers.showBtn.postMessage('1');
      }
    },
    // 点击周边详情，是否展示状态栏，app回调
    toolbarChange(){
      console.log("toolbarChangetoolbarChangetoolbarChangetoolbarChange")
      this.toolbar = true;
    },
    ...mapMutations(["setSearchObj"]),
    async userDataPermission(){
      let _this=this;
      await new Promise((resolve) => {
          _this.$api.User.userDataPermission(_this.userinfo.uid).then(res=>{
            if(res && res.code == 1){
              let arr=[],hideArr=[];
              if(res.data.dataType.length>0){
                res.data.dataType.forEach(item=>{
                  arr.push("geo_"+item)
                })
              }
              _this.baseGisType.forEach(baseItem=>{
                for(var i=0;i<arr.length;i++){
                  if(baseItem==arr[i]){
                    return false;
                  }
                }
                hideArr.push(baseItem)
              })
              _this.dataGisType=JSON.parse(JSON.stringify(hideArr));
              _this.dataGisType.push("lz_task")//这里任务不展示，之战时当前任务
              if(hideArr.length>0){
                // _this.$emit("on-load",true)
                _this.isFilter=true;
              }
            }else{
              _this.$toast(res.msg);
            }
            resolve();
          })
      });
    },
    loadMap() {
      var _this = this;

      if (_this.userinfo && _this.userinfo.appId) {
        this.$api.Mapapi.getconfig({
          appId: _this.userinfo.appId,
        })
          .then(async (res) => {
            if (res && res.code == "1") {
              _this.clearDiv();
              _this.gisconfig = res.data;
              let gisConfigList=_this.gisconfig.gisConfigList
              for(var i=0;i<gisConfigList.length;i++){
                var item = gisConfigList[i];
                if(item.layerName!='政区网格' && item.layerName!='底图数据'){
                  if (item.subConfigList && item.subConfigList.length > 0) {
                    for (var j = 0; j < item.subConfigList.length; j++) {
                      var subitem = item.subConfigList[j];
                      if(subitem.layerType=='geo_xiaoban'){
                        subitem.isShow=true;
                      }else{
                        subitem.isShow=false;
                      }
                    }
                  }
                }
                
              }
              var treeedata = getLayerTree(_this.gisconfig, "vantTreeSelecter");

              _this.layercontrol.items = treeedata.rows;
              _this.layercontrol.activeIds = treeedata.selecetd;
              var detaillayers = getLayerTree(_this.gisconfig, "vantSelect");
              _this.layerpicker.layerItems = detaillayers.rows;
              //设置该地图根据CQL进行过滤加载
              _this.gisconfig.queryWithCQL = true;
              //设置CQL进行查询，必须要提供uid、uregion、uregionlevel三个参数
              _this.gisconfig.uid = _this.userinfo.uid;
              _this.gisconfig.uregion = _this.userinfo.zqCode;
              _this.gisconfig.uregionlevel = [
                null,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                5,
              ][_this.gisconfig.uregion.length];
              _this.sth = _this.gisconfig.censorNumber;
              //初始化地图

              _this.map = initMap("zrqmap", _this.gisconfig, {
                showZoom: false,
              });
              _this.map.gisConfig = res.data;
              _this.map.addControl(new ScaleLine());
              _this.mapEvtBind(); //绑定地图事件
              //添加图层
              // addLayerToMap(_this.map, _this.gisconfig, ["lz_user"]); //原先是默认人员不显示
              await _this.userDataPermission();//获取脱敏的数据接口
              addLayerToMap(_this.map, _this.gisconfig,_this.dataGisType);
              actLocateOne(_this.map,_this.param.type,_this.param.objid);
              addLocateLayerToMap(_this.map);
              _this.initVectorLayer();
              // //如果存在责任区，才展示所有功能(责任区参数可能是由路由传递，也有可能是由param组件传递)
              // if (_this.$route.query.zrqobjid && _this.$route.query.zrqlx) {
              //   _this.currentZrqlx = _this.$route.query.zrqlx;
              //   _this.currentZrqObjid = _this.$route.query.zrqobjid;
              // }
              if (_this.mapData.zrqobjid && _this.mapData.zrqlx) {
                _this.currentZrqlx = _this.mapData.zrqlx;
                _this.currentZrqObjid = _this.mapData.zrqobjid;
              }
              if (_this.currentZrqlx && _this.currentZrqObjid) {
                //默认选中下级责任区（操作tab）
                let gridtypes = [
                    "geo_grid_sheng",
                    "geo_grid_shi",
                    "geo_grid_xian",
                    "geo_grid_xiang",
                    "geo_grid_cun",
                  ],
                  zqTypes = [
                    "geo_sheng",
                    "geo_shi",
                    "geo_xian",
                    "geo_xiang",
                    "geo_cun",
                  ],
                  gridIndex = gridtypes.indexOf(_this.currentZrqlx),
                  zqIndex = zqTypes.indexOf(_this.currentZrqlx),
                  _nextLevelGridType;

                // if (gridIndex >= 0 && gridIndex < 4) {
                //   _nextLevelGridType = gridtypes[gridIndex + 1];
                // } else if (zqIndex >= 0 && zqIndex < 4) {
                //   _nextLevelGridType = gridtypes[zqIndex + 1];
                // }
                if(_this.dataGisType.indexOf("geo_xiaoban")==-1){
                  _nextLevelGridType="geo_xiaoban";
                }
                if (
                  _this.layerpicker.layerItems &&
                  _this.layerpicker.layerItems.length > 0 &&
                  _nextLevelGridType
                ) {
                  _this.layerpicker.layerItems.forEach((item) => {
                    if (item.children && item.children.length > 0) {
                      item.children.forEach((subitem) => {
                        if (subitem.type == _nextLevelGridType) {
                          _this.layerpicker.currentLayer = subitem;
                        }
                      });
                    }
                  });
                  console.log(_this.layerpicker.currentLayer);
                }
                //定位责任区
                _this.setSearchObj({
                  zrqlx: _this.currentZrqlx,
                  objid: _this.currentZrqObjid,
                  zqCode:_this.mapData.zqCode
                });
                
                this.$nextTick(() => {
                  actLocate(
                    _this.map,
                    _this.currentZrqlx,
                    _this.currentZrqObjid,
                    _this.zrqVector,
                    function () {
                      _this.zrqFeature = _this.zrqSourceVector.getFeatures()[0];
                      if (_this.zrqFeature) {
                        _this.haszrq = true;
                        //取消掉之前任意时候都裁切（提高App端地图拖拽的性能），改为判断只有当责任区赋值并且小于当前地图可视范围的四至才裁切
                        // _this.vectorLayerEvtBind(_this.zrqFeature.getGeometry())
                        _this.cutfeature = _this.zrqFeature; //将要裁切的责任区图形交给cutfeature，后者会监听一旦该变量赋值，执行裁切操作
                      } else {
                        _this.showNoZrqInfo = true;
                        removeAllLayersExceptBaseMap(_this.map);
                      }
                    }
                  );
                  
                  actLocate(_this.map,_this.param.type,_this.param.objid)
                });
              } else {
                _this.showNoZrqInfo = true;
                removeAllLayersExceptBaseMap(_this.map);
              }
            } else {
              _this.$toast(res.msg);
            }
          })
          .catch((err) => {
            _this.$toast(_this.$t("gisMsg.mapLoadFalseTip"));
          });
      }
    },
    mapEvtBind() {
      var _this = this;
      this.map.on("singleclick", function (evt) {
        var layerType = _this.layerpicker.currentLayer.type;
        if(_this.dataGisType.indexOf(layerType)!=-1 && layerType!='lz_task'){//脱敏数据不展示信息
          var vectorSource = getLocateLayer(_this.map).getSource();
          vectorSource.clear();
          return false;
        }
        if (_this.layerpicker.currentLayer.type == "zq") {
          if (
            _this.map.getView().getResolution() <
            getLayerByType(_this.map, "geo_cun").getMaxResolution()
          ) {
            layerType = "geo_cun";
          } else if (
            _this.map.getView().getResolution() <
            getLayerByType(_this.map, "geo_xiang").getMaxResolution()
          ) {
            layerType = "geo_xiang";
          } else if (
            _this.map.getView().getResolution() <
            getLayerByType(_this.map, "geo_xian").getMaxResolution()
          ) {
            layerType = "geo_xian";
          } else if (
            _this.map.getView().getResolution() <
            getLayerByType(_this.map, "geo_shi").getMaxResolution()
          ) {
            layerType = "geo_shi";
          } else if (
            _this.map.getView().getResolution() <
            getLayerByType(_this.map, "geo_sheng").getMaxResolution()
          ) {
            layerType = "geo_sheng";
          }
        }
        if (
          _this.optcontrol.queryProps &&
          _this.layerpicker.currentLayer &&
          _this.layerpicker.currentLayer.type &&
          _this.layerpicker.currentLayer.type != "google" &&
          _this.layerpicker.currentLayer.type != "tdt" &&
          _this.layerpicker.currentLayer.type != "tdtjd" &&
          _this.layerpicker.currentLayer.type != "tdtzj"
        ) {
          if(layerType == "lz_task"){
            _this.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
              console.log(feature,'featurefeature')
              if(feature && feature.dhfeaturetype == "lz_task"){
                let obj={};
                let o=feature.getProperties().obj;
                var taskid = feature.getId().replace("lz_task.", "")
                taskid=taskid.replace("lz_task_locate.", "");
                var vectorSource = getLocateLayer(_this.map).getSource();
                    vectorSource.clear();
                    vectorSource.addFeature(feature)
                // if (_this.clientType == "android") {
                //   window.android.getInfo(114, taskid);
                // } else {
                //   window.webkit.messageHandlers.openTaskDetial.postMessage(
                //     taskid
                //   );
                // }
              }else{
                _this.$toast('未查询到资源')
              }
                

            })
          }else{
            actLocateByCoordinate(
              _this.map,
              evt.coordinate,
              layerType,
              function (target) {
                // if (target && target.dhfeaturetype == "lz_task") {
                //   var taskid = target.getId().replace("lz_task.", "");
                //   if(target.getProperties().objid!=_this.param.objid){
                //     var vectorSource = getLocateLayer(_this.map).getSource();
                //     vectorSource.clear();
                //     return false;
                //   }
                //   if (_this.clientType == "android") {
                //     window.android.getInfo(114, taskid);
                //   } else {
                //     window.webkit.messageHandlers.openTaskDetial.postMessage(
                //       taskid
                //     );
                //   }
                // } else if (target) {
                  console.log(target,"target")
                  if(target.dhfeaturetype=='geo_gushu'){
                    _this.propertycontrol.id = target.getProperties().id;
                  }else{
                    _this.propertycontrol.id = target.getProperties().objid;
                  }
                  // 关闭按钮
                  _this.toolbar = false;
                  if (_this.clientType == "android") {
                    window.android.getInfo(123,'0');
                  } else {
                    window.webkit.messageHandlers.showBtn.postMessage('0');
                  }
                  if(_this.dataGisType.indexOf(layerType)!=-1){
                      var vectorSource = getLocateLayer(_this.map).getSource();
                      vectorSource.clear();
                  }
                  _this.propertycontrol.type = target.dhfeaturetype;
                  _this.showOptControl = _this.showLayerControl = _this.showRenderControl = _this.showSearchControl = false;
                  _this.showPropertyControl = true; 
                // }
              }
            );
          }
          
        }
      });
      this.map.on("moveend", function (e) {
        console.log("moveend");
        setTimeout(function () {
          var sacle = document.getElementsByClassName("ol-scale-line-inner")[0]
            .innerText;
          _this.optcontrol.scaleinfo =
            _this.map.getView().getZoom().toFixed(1) + " (1:" + sacle + ")";
        }, 200);
        if (_this.cutfeature) {
          if (
            _this.withIn(
              _this.cutfeature.getGeometry(),
              _this.map.getView().calculateExtent()
            )
          ) {
            _this.cutflag = false;
          } else {
            _this.cutflag = true;
          }
        }
      });
    },
    // vectorLayerEvtBind(zrqgeomery){
    //   var _this = this
    //   this.map.getLayers().getArray().forEach(clayer=>{
    //     if(clayer.dhlayertype != undefined && clayer.dhlayertype != 'locatelayer'){
    //       clayer.on('precompose', function (event) {
    //           var ctx = event.context;
    //           var pixelRatio = event.frameState.pixelRatio;
    //           var vecCtx = event.vectorContext;
    //           ctx.save();
    //           vecCtx.setStyle(_this.blankStyle);
    //           vecCtx.drawGeometry(zrqgeomery);
    //           ctx.clip();
    //       });
    //       clayer.on('postcompose', function (event) {
    //           var ctx = event.context;
    //           ctx.restore();
    //       });
    //     }
    //   });
    // },
    handleCut() {
      var _this = this;
      
      if (this.cutflag && this.cutfeature) {
        console.log("this.handleCut();,99999000000000000000000000000000000000")
        console.log(_this.map
          .getLayers()
          .getArray())
        _this.map
          .getLayers()
          .getArray()
          .forEach((clayer) => {
            clayer.on("precompose", _this.beginCut);
            clayer.on("postcompose", _this.endCut);
          });
      } else {
        _this.map
          .getLayers()
          .getArray()
          .forEach((clayer) => {
            clayer.un("precompose", _this.beginCut);
            clayer.un("postcompose", _this.endCut);
          });
      }
    },
    beginCut(event) {
      var ctx = event.context;
      var vecCtx = event.vectorContext;
      ctx.save();
      if (this.cutfeature.getGeometry().constructor === MultiPolygon) {
        vecCtx.setStyle(this.blankStyle);
      }
      vecCtx.drawGeometry(this.cutfeature.getGeometry());
      ctx.clip();
    },
    endCut(event) {
      var ctx = event.context;
      ctx.restore();
    },
    withIn(polygon, extent) {
      var topleft = getTopLeft(extent),
        topright = getTopRight(extent),
        bottomleft = getBottomLeft(extent),
        bottomRight = getBottomRight(extent);
      if (
        polygon.intersectsCoordinate(topleft) &&
        polygon.intersectsCoordinate(topright) &&
        polygon.intersectsCoordinate(bottomleft) &&
        polygon.intersectsCoordinate(bottomRight)
      ) {
        return true;
      }
      return false;
    },
    onTargetLayerConfirm(value, index) {
      this.layerpicker.currentLayer = this.layerpicker.layerItems[
        index[0]
      ].children[index[1]];
      this.layerpicker.showpicker = false;

      this.beginJuanlian();
    },

    onChange(index) {
      this.symbolcontrol.showsymbol = false;
      this.showPropertyControl = false;
      this.showLayerControl = this.showRenderControl = this.showSearchControl = this.showOptControl = false;
      var indexName = [
        "showLayerControl",
        "showRenderControl",
        "showSearchControl",
        "showOptControl",
      ][index];
      this[indexName] = true;
    },
    initVectorLayer() {
      //初始化一个责任区矢量图层，用于绘制责任区
      var _this = this;
      this.zrqSourceVector = new VectorSource();
      this.zrqVector = new VectorLayer({
        source: this.zrqSourceVector,
        style: function (feature) {
          return _this.zrqStyle;
        },
      });
      this.map.addLayer(this.zrqVector);
    },
    handleLayerVisible(data) {
      let _this=this;
      if(_this.dataGisType.indexOf(data.type)==-1){//如果是五个保密数据类型：小班、湿地、基本农田、生态红线、自然保护地要进行脱敏判断
        actTroggleLayer(this.map, data.type);
      }  
    },
    handleRenderSelect(data) {
      if (data == 0) {
        this.rendercontrol.activeIds = this.rendercontrol.lindiType;
      } else if (data == 1) {
        this.rendercontrol.activeIds = this.rendercontrol.shidiType;
      } else if (data == 2) {
        this.rendercontrol.activeIds = this.rendercontrol.baohudiType;
      }
    },
    handleRenderItemSelect(data) {
      if (data.type == "geo_xiaoban") {
        this.rendercontrol.lindiType = data.id;
      } else if (data.type == "geo_shidi") {
        this.rendercontrol.shidiType = data.id;
      } else if (data.type == "geo_baohudi") {
        this.rendercontrol.baohudiType = data.id;
      }
      actRenderLayer(this.map, data.type, data.id);
    },
    beginJuanlian() {
      var _this = this;
      if (
        this.juanlian == true &&
        this.layerpicker.currentLayer &&
        this.layerpicker.currentLayer.type
      ) {
        //取消之前的卷帘监听
        this.map
          .getLayers()
          .getArray()
          .forEach((clayer) => {
            clayer.un("precompose", _this.handleBeginRender);
            clayer.un("postcompose", _this.handleEndRender);
          });
        //重新卷帘
        if (_this.layerpicker.currentLayer.type == "zq") {
          var zqlayers = [
            "geo_sheng",
            "geo_shi",
            "geo_xian",
            "geo_xiang",
            "geo_cun",
          ];
          for (var lidx in zqlayers) {
            var layer = getLayerByType(this.map, zqlayers[lidx]);
            layer.on("precompose", this.handleBeginRender);
            layer.on("postcompose", this.handleEndRender);
          }
        } else {
          var layer = getLayerByType(
            this.map,
            this.layerpicker.currentLayer.type
          );
          layer.on("precompose", this.handleBeginRender);
          layer.on("postcompose", this.handleEndRender);
        }
      }
    },
    handleBeginRender(event) {
      var ctx = event.context;
      var width = ctx.canvas.width * (this.slidercontrol.sliderValue / 100);
      ctx.save();
      ctx.beginPath();
      ctx.rect(width, 0, ctx.canvas.width - width, ctx.canvas.height);
      ctx.clip();
    },
    handleEndRender(event) {
      var ctx = event.context;
      ctx.restore();
    },
    handleSliding() {
      this.map.render();
    },
    handleLocate(objid, type) {
      let _this=this;
      if (objid && type) {
        this.showPropertyControl = false;
        this.showSearchControl = false;
        actLocate(_this.map, type, objid,null,()=>{
          if(_this.dataGisType.indexOf(type)!=-1){
            let vectorSource = getLocateLayer(_this.map).getSource();
            vectorSource.clear();
          }
        });
      }
    },
    setview() {
      var _this = this;
      if (_this.currentZrqlx && _this.currentZrqObjid) {
        actLocate(
          _this.map,
          _this.currentZrqlx,
          _this.currentZrqObjid,
          _this.zrqVector,
          function () {
            _this.cutflag = true;
            _this.map.render();
          }
        );
      }
    },
    setmyview() {
      if (this.clientType == "android") {
        window.android.getInfo(116, null);
      } else {
        window.webkit.messageHandlers.updateMyPosition.postMessage(null);
      }
      this.$toast.loading({
        message: this.$t("gisMsg.getPositionTit"),
        duration: 0,
        forbidClick: true,
      });
    },
    clearDiv() {
      //找出地图上所有的覆盖DIV
      let box = document.getElementById("zrqmap");
      box.parentNode.removeChild(box);
      let pDiv = document.getElementById("dhmap-wrapper");
      let oDiv = document.createElement("div");
      oDiv.id = "zrqmap";
      pDiv.appendChild(oDiv);
    },
    locateByNative(lonlat) {
      this.$toast.clear();
      //添加当前人员位置
      console.log("lonlat======");
      console.log(lonlat);
      if (lonlat) {
        var cord = lonlat.split(" ");
        if (cord.length == 2) {
          this.map.getOverlays().clear();
          var centerFeature = new Feature(new Point(cord));
          centerFeature.setStyle(locateStyleCollection["default"]);
          var ele = document.createElement("div");
          ele.className = "localtemarker";
          var marker = new Overlay({
            position: cord,
            positioning: "center-center",
            element: ele,
            stopEvent: false,
          });
          this.map.addOverlay(marker);
          this.map.getView().animate({
            center: cord,
            duration: 500,
          });
        }
      }
    },
  },
  computed: {
    ...mapState(["userinfo", "closeShowType"]),
    fmtlonlat() {
      if (this.optcontrol.lonlat) {
        var cord = this.optcontrol.lonlat.split(",");
        console.log(cord,"cord")
        // console.log(cord,cord[0],cord[1])
        if (cord.length == 2) {
          return Number(cord[0]).toFixed(6) + "," + Number(cord[1]).toFixed(6);
        }
      }
      return "";
    },
  },
  watch: {
    userinfo: {
      handler: function () {
        let _this = this;
        if (_this.mapData.zrqlx && _this.mapData.zrqobjid && _this.userinfo) {
          // removeAllLayersExceptBaseMap(_this.map);
          //如果是组件引用，当检测到toolbar=none时，隐藏所有工具栏
          if (_this.mapData.toolbar === "none") {
            _this.toolbar = false;
          }
          _this.showNoZrqInfo = false;
          _this.loadMap();
        }
      },
      deep: true,
    },
    mapData: {
      handler: function () {
        let _this = this;
        if (_this.mapData.zrqlx && _this.mapData.zrqobjid && _this.userinfo) {
          // removeAllLayersExceptBaseMap(_this.map);
          //如果是组件引用，当检测到toolbar=none时，隐藏所有工具栏
          if (_this.mapData.toolbar == "none") {
            _this.toolbar = false;
          }
          _this.showNoZrqInfo = false;
          _this.loadMap();
        }
      },
      deep: true,
    },
    cutflag() {
      
      this.handleCut();
    },
    cutfeature() {
      this.handleCut();
    },

    showLayerControl() {
      if (
        this.showLayerControl == false &&
        this.showRenderControl == false &&
        this.showOptControl == false &&
        this.showSearchControl == false
      ) {
        this.active = -1;
      }
    },
    showRenderControl() {
      if (
        this.showLayerControl == false &&
        this.showRenderControl == false &&
        this.showOptControl == false &&
        this.showSearchControl == false
      ) {
        this.active = -1;
      }
    },
    showSearchControl() {
      if (
        this.showLayerControl == false &&
        this.showRenderControl == false &&
        this.showOptControl == false &&
        this.showSearchControl == false
      ) {
        this.active = -1;
      }
    },
    showOptControl() {
      if (
        this.showLayerControl == false &&
        this.showRenderControl == false &&
        this.showOptControl == false &&
        this.showSearchControl == false
      ) {
        this.active = -1;
      }
    },

    juanlian(val) {
      if (val == true) {
        var _this = this;
        if (
          this.layerpicker.currentLayer &&
          this.layerpicker.currentLayer.type
        ) {
          this.showOptControl = false;
          this.slidercontrol.showSlider = true;
          this.beginJuanlian();
        } else {
          this.$toast(this.$t("gisMsg.toastFalseMsg"));

          setTimeout(function () {
            _this.juanlian = false;
          }, 200);
        }
      } else {
        this.slidercontrol.showSlider = false;
      }
    },
  },
};
</script>

<style lang="less">
.dhmap-wrapper {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
}
.showSearchBox {
  padding-top: 8px !important;
  .van-icon.van-icon-cross.van-popup__close-icon {
    display: none;
  }
}
#zrqmap {
  width: 100%;
  height: 100%;
}
.poptitle {
  width: 100%;
  height: 50px;
  text-align: center;
  font-size: 14px;
  padding: 0px 15px;
  line-height: 50px;
  border-bottom: 1px solid #f3f3f3;
}
.van-tree-select__item {
  font-weight: normal;
}
.van-sidebar-item--select {
  border-color: #07c160;
}
.van-tree-select__item--active {
  color: #07c160;
}
.infotip {
  width: 100%;
  height: 30px;
  text-align: center;
  padding-top: 5px;
  color: #fff;
  font-size: 13px;
}
.symboltitle {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  line-height: 45px;
  padding-left: 15px;
}

.localtemarker {
  width: 40px;
  height: 40px;
  background: url("../../assets/gisicon/map-marker.png") center no-repeat;
  z-index: 999999;
}
.ol-scale-line {
  background: rgba(0, 60, 136, 0.3);
  border-radius: 0.10667rem;
  bottom: -60px;
  left: 0.21333rem;
  padding: 0.05333rem;
  position: absolute;
}

.gistoolbox {
  position: absolute;
  width: 50px;
  left: 10px;
  bottom: 70px;
  z-index: 2000;
}
.gisinfobox {
  position: absolute;
  width: 100%;
  right: 10px;
  text-align: right;
  color: #333;
  bottom: 70px;
  z-index: 1999;
}
.van-button--normal {
  padding: 0;
  margin-bottom: 10px;
  width: 32px;
  height: 32px;
  line-height: 36px;
}
.vanSwipe {
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0;
    background: #4bc985;
    height: 30px;
    z-index: 9;
    .van-icon{
      color: #fff;
    }
    .van-notice-bar__wrap {
      height: 25px;
    }
    .noticeSwiper {
      font-size: 12px;
      width: 350px;
      height: 25px;
      line-height: 25px;
      color: #fff;
      background: #4bc985;
      position: relative;
    }
  }
</style>